/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import cx from 'classnames';

import { Button } from '@coursera/cds-core';
import type { ButtonProps } from '@coursera/cds-core';

export type Props = { children: string; className?: string; selected?: boolean } & Omit<ButtonProps, 'children'>;

const styles = {
  mediumButton: css`
    padding: var(--cds-spacing-150) var(--cds-spacing-200);
  `,
};

/**
 * Rebrand CoachButton
 * Simple wrapper around CDS Button to provide Coach-specific styles.
 * Note: this should not be used outside of the parent `<CoachStylesProviderV2/>`
 */
export const CoachButton = (props: Props): React.ReactElement => {
  const { children, size = 'medium', variant, className, selected, ...rest } = props;

  if (variant === 'secondary') {
    return (
      <Button
        variant="secondary"
        className={cx('coach-button-v2', 'coach-secondary-button', className, { selected })}
        textAlign="start"
        size={size}
        css={size === 'medium' ? styles.mediumButton : undefined}
        {...rest}
      >
        {children}
      </Button>
    );
  } else if (variant === 'ghost') {
    return (
      <Button
        variant="ghost"
        className={cx('coach-button-v2', 'coach-ghost-button', className, { selected })}
        textAlign="start"
        size={size}
        css={size === 'medium' ? styles.mediumButton : undefined}
        {...rest}
      >
        {children}
      </Button>
    );
  } else {
    return (
      <Button
        className={cx('coach-button-v2', className, { selected })}
        textAlign="start"
        size={size}
        css={size === 'medium' ? styles.mediumButton : undefined}
        {...rest}
      >
        {children}
      </Button>
    );
  }
};

export default CoachButton;
